import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { ExpandMoreIcon, LockOpenIcon } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import ListChoice from "components/DesignComponents/ListChoice";
import Menu, {
    centeredTransformOrigin
} from "components/DesignComponents/Menu";
import { usePermissions } from "shared";

import { useDialog, useMenu } from "../../../Actions/ActionBar/hooks";
import { DEVICE_ACTIONS } from "../../../Actions/types";
import GenerateUnlockKeyDialog from "./GenerateUnlockKeyDialog";

const Actions = () => {
    const { t } = useTranslation();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useMenu();
    const { isOpenDialog, openDialog, closeDialog } = useDialog();

    const {
        isUnlockDeviceNotAllowed,
        PERMISSIONS,
        getNoPermissionTooltipTitle
    } = usePermissions();

    const handleOpenDialog = () => {
        openDialog(DEVICE_ACTIONS.GenerateUnlockKey);
        handleCloseMenu();
    };

    const handleCloseDialog = () =>
        closeDialog(DEVICE_ACTIONS.GenerateUnlockKey);

    return (
        <div onClick={e => e.stopPropagation()}>
            <Button
                color={BUTTON_COLORS.Secondary}
                size={BUTTON_SIZES.Small}
                variant={BUTTON_VARIANTS.IconRight}
                onClick={handleOpenMenu}
                icon={<ExpandMoreIcon />}
                css={css({
                    marginRight: "60px",

                    "@media(max-width: 839px)": {
                        margin: "16px 0 0 0"
                    }
                })}
            >
                {t("Button##actions")}
            </Button>

            <Menu
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                transformOrigin={centeredTransformOrigin}
                css={css({
                    "& .MuiMenu-paper": {
                        minWidth: "211px"
                    }
                })}
            >
                <ListChoice
                    title={t("Dialog##unlocker##generate unlock key")}
                    iconLeft={<LockOpenIcon />}
                    disabled={isUnlockDeviceNotAllowed}
                    tooltipText={getNoPermissionTooltipTitle(
                        PERMISSIONS.DeviceUnlock
                    )}
                    onClick={handleOpenDialog}
                />
            </Menu>

            <GenerateUnlockKeyDialog
                isOpen={isOpenDialog[DEVICE_ACTIONS.GenerateUnlockKey]}
                closeDialog={handleCloseDialog}
            />
        </div>
    );
};

export default Actions;
